import { useLocation } from "react-router-dom";

export default function ReportViewer() {
  const { state } = useLocation();
  const report = state?.report;

  if (!report) {
    return <h2>Report not found</h2>;
  }

 return (
    <div style={{ padding: "20px", fontFamily: "'Montserrat', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');`}</style>
      <h1>{report.project_name}</h1>

      <p>
        <strong>Client:</strong> {report.client_name}
      </p>

      <p>
        <strong>Status:</strong> {report.status}
      </p>

      <p>
        <strong>Report Type:</strong> {report.report_type}
      </p>

      <hr />

      <iframe
        src={`https://totalassureplus.com/api/uploads/${report.file_url}`}
        title="Report Preview"
        width="100%"
        height="700px"
      />
    </div>
  );
}